import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AutoLogoutState {
    idleTimeInSeconds: number | undefined;
}

const initialState: AutoLogoutState = {
    idleTimeInSeconds: undefined,
};

export const autoLogoutSlice = createSlice({
    name: "autoLogout",
    initialState,
    reducers: {
        setIdleTimeInSeconds: (state, action: PayloadAction<AutoLogoutState>) => {
            state.idleTimeInSeconds = action.payload.idleTimeInSeconds;
        },
    },
});

export const { setIdleTimeInSeconds } = autoLogoutSlice.actions;

export default autoLogoutSlice.reducer;
